import { Button, Grid, Typography } from '@mui/material';
import userOtpLogo from 'assets/Images/Auth/authotp.png';
import EnterOtpInput from 'components/Common/EnterOtpInput';
import OtpTimer from 'components/OtpTimer';
import Enums from 'constants/Enums';
import { getLocalStorageItem } from 'hooks';
import {
  useForgetPasswordSentCodeQuery,
  useResendCodeQuery,
} from 'queries/AuthQueries';
import type { FC } from 'react';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';

import { queryKeys } from '../../constants';

const VerifyMobilePopup: FC<{
  setOpen: any;
  verificationType?: any;
  template?: any;
  handleEmailVerified: (args: boolean) => void;
  handlePhoneVerified: (data: boolean) => void;
  updatedEmail?: string;
  updatedPhone?: string;
}> = ({
  setOpen,
  verificationType,
  template,
  handleEmailVerified,
  handlePhoneVerified,
  updatedEmail,
  updatedPhone,
}) => {
  const rolesLayout = getLocalStorageItem('roles');
  const [otp, setOtp] = useState<any>(0);
  const [over, setOver] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const { mutate: resendCodeApi } = useResendCodeQuery();
  const { mutate: verifyCodeApi } = useForgetPasswordSentCodeQuery();
  const queryClient = useQueryClient();
  const { t } = useTranslation('userLogin');
  const handleOver = () => {
    setOver(true);
  };
  const {
    handleSubmit,
    setError,
    reset,
    formState: { errors },
  } = useForm({});
  const submitAuthForm = () => {
    const submitPayload: any = {
      code: otp.toString(),
      sendOn: verificationType === 'Email' ? updatedEmail : updatedPhone,
      eventCode:
        verificationType === 'Email'
          ? Enums.EventType.EMAIL_VERIFY
          : Enums.EventType.PHONE_VERIFY,
    };
    verifyCodeApi(submitPayload, {
      onSuccess: () => {
        setOpen(false);
        if (verificationType === 'Email') {
          handleEmailVerified(true);
        } else {
          handlePhoneVerified(true);
        }
        queryClient.invalidateQueries([queryKeys.AUTH_ME]);
      },
      onError: (err: any) => {
        setErrorMessage(err?.fieldErrors[0]?.message);
      },
    });
  };
  const handleAuthErrors = () => {};

  useEffect(() => {
    if (otp?.length === 6) {
      submitAuthForm();
    }
  }, [otp]);

  return (
    <div className="mx-auto max-w-[592px] rounded-[12px] p-4 sm:p-6 md:p-8">
      <div className="mx-auto mb-4 text-center">
        <img src={userOtpLogo} alt="" className="mb-3" />
        <Typography
          fontWeight={600}
          variant="h5"
          color="secondary.100"
          align="center"
        >
          {`${t('verifyOtp')} ${
            verificationType === 'Email' ? 'EMAIL' : t('MobileNumber')
          } `}
        </Typography>

        <Typography
          fontWeight={600}
          variant="subtitle1"
          color="font.900"
          align="center"
          paddingTop={1.2}
          paddingBottom={1}
        >
          {template[0]}
          <span className="font-semibold text-[#2A323D]">
            {verificationType === 'Email' ? template[1] : template[1]}
          </span>
        </Typography>
      </div>

      <form
        id="verify-otp-form"
        onSubmit={handleSubmit(submitAuthForm, handleAuthErrors)}
      >
        <Grid item container spacing={2} xs={12}>
          <Grid item xs={12}>
            <EnterOtpInput
              otpDigit={6}
              custom={'verifyPin'}
              value={otp}
              onChange={(userOTP: string) => {
                setOtp(userOTP);
              }}
            />
          </Grid>
          {errorMessage && (
            <div className="m-auto flex items-center justify-center text-center">
              <p className="text-center text-md font-normal text-error-500">
                {errorMessage}
              </p>
            </div>
          )}
          <Grid item xs={12}>
            <Button
              id="verify-otp-form"
              fullWidth
              type="submit"
              disabled={otp === 0 || otp === ''}
            >
              {t('Confirm')}
            </Button>
          </Grid>
          {!over && (
            <div className="!w-full pt-3 md:w-[100%] md:pt-0 md:text-right">
              <OtpTimer
                minutes={1}
                seconds={0}
                over={over}
                handleOver={handleOver}
              />
            </div>
          )}
          {over && (
            <div className="!w-full pt-3 md:w-[100%] md:pt-0 md:text-right">
              <Typography
                fontWeight={600}
                variant="subtitle1"
                color="primary.600"
                align="center"
                paddingTop={2}
                className="hover:cursor-pointer"
                onClick={() => {
                  const payload: any = {
                    sendOn:
                      verificationType === 'Email'
                        ? updatedEmail
                        : updatedPhone,
                    eventCode:
                      verificationType === 'Email'
                        ? Enums.EventType.EMAIL_VERIFY
                        : Enums.EventType.PHONE_VERIFY,
                  };
                  resendCodeApi(payload);
                  setOver(false);
                }}
              >
                {t('resendCode')}
              </Typography>
            </div>
          )}
        </Grid>
      </form>
    </div>
  );
};

export default VerifyMobilePopup;
